/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_04_TitleInputs */

const en_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silent Nature`)
};

const ar_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طبيعة صامتة`)
};

const bn_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিঃশব্দ প্রকৃতি`)
};

const de_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stille Natur`)
};

const es_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturaleza silenciosa`)
};

const fr_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nature silencieuse`)
};

const pt_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natureza silenciosa`)
};

const zh_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寂静的自然`)
};

const tr_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessiz Doğa`)
};

const ru_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тихая природа`)
};

const pl_elastic_gallery_item_04_title = /** @type {(inputs: Elastic_Gallery_Item_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cicha natura`)
};

/**
* | output |
* | --- |
* | "Silent Nature" |
*
* @param {Elastic_Gallery_Item_04_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_04_title = /** @type {((inputs?: Elastic_Gallery_Item_04_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_04_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_04_title(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_04_title(inputs)
	if (locale === "de") return de_elastic_gallery_item_04_title(inputs)
	if (locale === "es") return es_elastic_gallery_item_04_title(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_04_title(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_04_title(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_04_title(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_04_title(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_04_title(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_04_title(inputs)
	return en_elastic_gallery_item_04_title(inputs)
});